<template>
  <StepComponent>
    <v-row>
      <v-col cols="12" sm="6">
        <vue-tel-input-vuetify
          v-model="workPhone"
          id="workPhone"
          label="Work Phone"
          :rules="rules.phone"
          v-bind="bindProps"
        ></vue-tel-input-vuetify>
      </v-col>
      <v-col cols="12" sm="6">
        <vue-tel-input-vuetify
          v-model="homePhone"
          label="Home Phone"
          :rules="rules.phone"
          v-bind="bindProps"
        ></vue-tel-input-vuetify>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <vue-tel-input-vuetify
          v-model="mobilePhone"
          id="mobilePhone"
          label="Mobile Phone"
          :rules="rules.phone"
          v-bind="bindProps"
        ></vue-tel-input-vuetify>
      </v-col>
      <v-col cols="12" sm="6">
        <vue-tel-input-vuetify
          v-model="faxNumber"
          id="faxNumber"
          label="Fax Number"
          v-bind="bindProps"
          :rules="rules.fax"
        ></vue-tel-input-vuetify>
      </v-col>
    </v-row>
    <v-row
      v-for="(email, index) in client.clients_email_addresses"
      :key="index"
    >
      <v-col :cols="index === 0 ? 11 : 6">
        <v-text-field
          type="email"
          v-model="email.email_address"
          :id="`email_${index}`"
          :rules="rules.email"
          :label="emailLabel(index)"
        ></v-text-field>
      </v-col>
      <v-col cols="4" v-if="index > 0">
        <v-checkbox
          v-model="email.receive_copy_of_all"
          id="receive_copy_of_all"
          label="Receive Copy of Primary Email"
        ></v-checkbox>
      </v-col>
      <v-col cols="1" v-if="index > 0">
        <v-icon id="deleteEmail" @click="deleteEmail(index)">mdi-minus</v-icon>
      </v-col>
      <v-col cols="1">
        <v-icon id="addEmail" @click="addEmail">mdi-plus</v-icon>
      </v-col>
    </v-row>
  </StepComponent>
</template>

<script>
import StepComponent from "@/components/registration/AccountSetupSteps/StepComponent";
import { mapActions, mapMutations, mapGetters } from "vuex";
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import rules from "@/utils/rules";
import VueTelInputVuetify from "vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue";
import "vuetify/dist/vuetify.min.css";

export default {
  name: "ContactInformationStep",
  components: { StepComponent, VueTelInputVuetify },
  data() {
    return {
      rules: {
        email: [rules.required, rules.email],
        required: [rules.required],
        phone: [
          number =>
            /^\s*[-()0-9+ ]+\s*$/.test(number) ||
            number === "" ||
            "Invalid phone number (digits only allowed). Keep adding digits to remove invalid characters",
          rules.required
        ],
        fax: [
          number =>
            /^\s*[-()0-9+ ]+\s*$/.test(number) ||
            number === "" ||
            "Invalid fax number (digits only allowed). Keep adding digits to remove invalid characters"
        ]
      },
      bindProps: {
        mode: "international",
        disabledFetchingCountry: true,
        defaultCountry: "US"
      }
    };
  },
  computed: {
    ...mapGetters("clients", ["selectedClient"]),
    workPhone: {
      get() {
        return this.client.work_phone || "";
      },
      set(val) {
        this.client.work_phone = val;
      }
    },
    homePhone: {
      get() {
        return this.client.home_phone || "";
      },
      set(val) {
        this.client.home_phone = val;
      }
    },
    mobilePhone: {
      get() {
        return this.client.mobile_phone || "";
      },
      set(val) {
        this.client.mobile_phone = val;
      }
    },
    faxNumber: {
      get() {
        return this.client.fax || "";
      },
      set(val) {
        this.client.fax = val;
      }
    },
    ...mapFields("clients", [
      "items[0].work_phone",
      "items[0].home_phone",
      "items[0].mobile_phone",
      "items[0].fax",
      "client"
    ]),
    ...mapMultiRowFields("clients", ["items[0].clients_email_addresses"])
  },
  methods: {
    ...mapMutations("clients", ["addEmail", "deleteEmail"]),
    ...mapMutations("clients", { workPhoneMutation: "updateWorkPhone" }),
    ...mapActions("clients", ["getClients", "updateClientContactInfo"]),
    emailLabel(idx = 0) {
      return idx === 0 ? "Primary Email" : "Email";
    },
    beforeContinue() {
      return this.updateClientContactInfo().catch(e => {
        console.error(e);
        return false;
      });
    }
  },
  mounted() {
    this.client = this.selectedClient;
    Promise.all([this.getClients()]).then(() => {
      if (this.client.clients_email_addresses.length === 0) {
        this.addEmail();
        this.client.clients_email_addresses[0]["email_address"] =
          this.$store.state.auth.user.email ||
          this.$store.state.auth.user.username;
      }
    });
  },
  watch: {
    selectedClient(newVal) {
      this.client = newVal;
    }
  }
};
</script>
